<img class="mx-auto" src="https://static.rinconvista.com/rinconvista_logo.png" alt="Rincon Vista logo" />
<app-login class="p-50"></app-login>
